import VueI18n from 'vue-i18n';
import en from './en';
import pl from './pl';

const messages = {
  en,
  pl,
};

const i18n = new VueI18n({
  locale: 'pl',
  fallbackLocale: 'pl',
  messages,
});


export default i18n;
